import React, { useState } from "react";
import { gettext } from "../../shared/utils/legacy";
import SubMenuSideBar from "../../shared/components/SubMenuSideBar";
import RainDancerStatus from "./RainDancerStatus";

const RainDancer = () => {
  const [active, setActive] = useState("index");
  return (
    <div className="container-fluid clearfix">
      <div className="row wrapper clearfix">
        <SubMenuSideBar
          menu={{
            Raindancer: {
              index: gettext("Overview"),
            },
          }}
          active={active}
          setActive={setActive}
        />
        <div className="col-9 bg-white s-b p-3">{active === "index" && <RainDancerStatus />}</div>
      </div>
    </div>
  );
};

export default RainDancer;
